<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor="rgba(255,255,255,0.8)" size="large" color="#0058ff" type="ball-scale-pulse" [fullScreen]="true">
  <p style="color: black">กำลังโหลดข้อมูล...</p>
</ngx-spinner>

<div class="content-wrapper" style="min-height: 307px">
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-4">
          <h4 class="text-primary">BRD Summary Report {{year_S.yearDesc}}</h4>
        </div>
        <div class="col-8">
          <table>
            <tr>
              <td>
                <mat-form-field appearance="fill" style="text-align:center">
                  <mat-label>กรุณาเลือกปี </mat-label>
                  <mat-select disableRipple required [(ngModel)]="year_S" (selectionChange)="select_year()"
                    [disabled]="loader" style="text-align:center">
                    <mat-option [value]="" disabled>-- เลือกปี --</mat-option>
                    <mat-option *ngFor="let item of year_L" [value]="item">{{item.yearDesc}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field appearance="fill" style="text-align:center" *ngIf="f_allkpidata.length > 0">
                  <mat-label>เลือกโซน/ส่วน</mat-label>
                  <mat-select disableRipple required [(ngModel)]="selectS" (ngModelChange)="filter_data()"
                    [disabled]="loader||s_list==5" style="text-align:center">
                    <mat-option *ngFor="let item of selectsup" [value]="item">
                      {{item[3]}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </td>
              <td>
                <button mat-raised-button color="primary" (click)="select_year()">ตกลง/โหลดใหม่</button>
              </td>
            </tr>
          </table>
        </div>
        <mat-progress-bar mode="indeterminate" *ngIf="loader"></mat-progress-bar>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-2 mb-2" style="text-align:center">
          <button class="btn btn-sm" [ngClass]="showMenu ? 'btn-danger' : 'btn-success'" (click)="toggleMenu()"
            style="min-width: 120px;">
            <i class="fas" [ngClass]="showMenu ? 'fa-times' : 'fa-bars'"></i>
            {{ showMenu ? 'ซ่อนเมนู' : 'แสดงเมนู' }}
          </button>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-md-auto" style="text-align:center" *ngIf="showMenu">
          <div class="nav nav-tabs h-20 justify-content-center" id="vert-tabs-tab" role="tablist"
            aria-orientation="horizontal">
            <a class="nav-link btn btn-outline-secondary" (click)="Swaptab(2);" data-toggle="pill" role="tab">นสส</a>
            <a class="nav-link btn btn-outline-secondary active" (click)="Swaptab(1);" data-toggle="pill"
              role="tab">โซน</a>
            <a class="nav-link btn btn-outline-secondary" (click)="Swaptab(3);" data-toggle="pill" role="tab"
              *ngIf="!slz">ส่วน</a>
          </div>
          <div class="nav flex-column nav-tabs h-90" id="vert-tabs-tab" role="tablist" aria-orientation="vertical">
            <a class="nav-link btn btn-outline-success" id="vert-tabs-cane-tab" (click)="s_list=15; click_list();"
              data-toggle="pill" href="#vert-tabs-cane" role="tab">%ข้อมูลอ้อย</a>
            <a class="nav-link btn btn-outline-success active" id="vert-tabs-allcane-tab"
              (click)="s_list=1; click_list();" data-toggle="pill" href="#vert-tabs-allcane" role="tab">ปริมาณอ้อย</a>
            <a class="nav-link btn btn-outline-success" id="vert-tabs-ton-tab" (click)="s_list=23; click_list();"
              data-toggle="pill" href="#vert-tabs-ton" role="tab">เทียบประเมินอ้อย</a>
            <!--<a class="nav-link " id="vert-tabs-Assess-tab" (click)="s_list=24; click_list();" data-toggle="pill" href="#vert-tabs-Assess" role="tab" >เทียบปริมาณอ้อย</a>-->
            <a class="nav-link btn btn-outline-success" id="vert-tabs-output-tab" (click)="s_list=2; click_list();"
              data-toggle="pill" href="#vert-tabs-output" role="tab">ผลผลิต</a>
            <!-- 
              <a class="nav-link" id="vert-tabs-yildAdd-tab" (click)="TopicTwo1Chart();" data-toggle="pill" href="#vert-tabs-yildAdd" role="tab" >เพิ่มผลผลิต</a>
              -->
            <a class="nav-link btn btn-outline-success" id="vert-tabs-area-tab" (click)="s_list=3; click_list();"
              data-toggle="pill" href="#vert-tabs-area" role="tab">พื้นที่ปลูก </a>
            <a class="nav-link btn btn-outline-success" id="vert-tabs-job-tab" (click)="s_list=14; click_list();"
              data-toggle="pill" href="#vert-tabs-job" role="tab">%กิจกรรม</a>
            <a class="nav-link btn btn-outline-success" id="vert-tabs-update-tab" (click)="s_list=16; click_list();"
              data-toggle="pill" href="#vert-tabs-update" role="tab">อัพเดตแปลง</a>

            <a class="nav-link btn btn-outline-success" id="vert-tabs-dindan-tab" (click)="s_list=4; click_list();"
              data-toggle="pill" href="#vert-tabs-dindan" role="tab">ระเบิดดาน</a>
            <a class="nav-link btn btn-outline-success" id="vert-tabs-canetype-tab" (click)="s_list=5; click_list();"
              data-toggle="pill" href="#vert-tabs-canetype" role="tab"> พันธุ์อ้อย</a>
            <a class="nav-link btn btn-outline-success" id="vert-tabs-rangland-tab" (click)="s_list=6; click_list();"
              data-toggle="pill" href="#vert-tabs-rangland" role="tab">ระยะร่อง</a>

            <a class="nav-link btn btn-outline-success" id="vert-tabs-chame1-tab" (click)="s_list=7; click_list();"
              data-toggle="pill" href="#vert-tabs-chame1" role="tab">เคมี 1</a>
            <a class="nav-link btn btn-outline-success" id="vert-tabs-chame2-tab" (click)="s_list=8; click_list();"
              data-toggle="pill" href="#vert-tabs-chame2" role="tab">เคมี 2</a>
            <a class="nav-link btn btn-outline-success" id="vert-tabs-chame3-tab" (click)="s_list=9; click_list();"
              data-toggle="pill" href="#vert-tabs-chame3" role="tab">เคมี 3</a>
            <a class="nav-link btn btn-outline-success" id="vert-tabs-ferti-tab" (click)="s_list=10; click_list();"
              data-toggle="pill" href="#vert-tabs-ferti" role="tab"> อินทรีย์</a>
            <a class="nav-link btn btn-outline-success" id="vert-tabs-dolomite-tab" (click)="s_list=11; click_list();"
              data-toggle="pill" href="#vert-tabs-dolomite" role="tab">โดโลไมท์</a>

            <a class="nav-link btn btn-outline-success" id="vert-tabs-rategrow-tab" (click)="s_list=12; click_list();"
              data-toggle="pill" href="#vert-tabs-rategrow" role="tab">% งอก</a>
            <a class="nav-link btn btn-outline-success" id="vert-tabs-weed-tab" (click)="s_list=13; click_list();"
              data-toggle="pill" href="#vert-tabs-weed" role="tab">วัชพืช</a>
            <a class="nav-link btn btn-outline-success" id="vert-tabs-fmgrade-tab" (click)="s_list=25; click_list();"
              data-toggle="pill" href="#vert-tabs-fmgrade" role="tab">เกรดชาวไร่</a>

            <!--
              <a class="nav-link btn btn-outline-success" id="vert-tabs-bug-tab" data-toggle="pill" href="#vert-tabs-bug" role="tab"  >โรคแมลง (US)</a>
              <a class="nav-link btn btn-outline-success" id="vert-tabs-base-tab" data-toggle="pill" href="#vert-tabs-base" role="tab">การพูนโคน (US)</a>                        
              
              <a class="nav-link btn btn-outline-success" id="vert-tabs-finance-tab" (click)="s_list=17; click_list();" data-toggle="pill"
                href="#vert-tabs-finance" role="tab">สินเชื่อ</a>-->
          </div>
        </div>
        <div [ngClass]="showMenu ? 'col-md-10' : 'col-md-12'">
          <div class="tab-content" id="vert-tabs-tabContent">
            <div class="tab-pane text-left fade active show" id="vert-tabs-allcane" role="tabpanel"
              aria-labelledby="vert-tabs-allcane-tab">
              <div class="container-fluid">
                <div class="row">
                  <div class="row" *ngFor="let item of partlist">
                    <!--
                            <div class="col-12 col-sm-6 col-md-4">
                              <div class="small-box bg-info">
                                <div class="inner">
                                  <h2 style="font-weight: bold;">{{item.Assess_b | number:'1.2-2'}}</h2>
                                  <p style="font-weight: bold; color: #fff;">{{item.pc_targrt_Assess_b}}% จากเป้าหมาย {{item.targrt_Assess | number:'1.2-2'}}</p>
                                  <div class="progress progress-sm">
                                    <div class="progress-bar" [ngStyle]="{'width': item.pc_targrt_Assess_b+'%'}"></div>
                                  </div>
                                </div>
                                <div class="icon">
                                  <i class=" fas fa-sort-amount-up"></i>
                                </div>
                                <a href="#" class="small-box-footer">
                                  จากการคำนวณของระบบ <i class=" fas fa-database"></i>

                                </a>
                              </div>
                            </div>
                            -->
                    <div class="col"></div>
                    <div class="col-sm-5 " style="text-align:center">
                      <div class="small-box bg-success">
                        <div class="inner">
                          <h2 style="font-weight: bold;">{{item.Assess | number:'1.2-2'}}</h2>
                          <p style="font-weight: bold; color: #fff;">{{item.pc_targrt_Assess}}% จากเป้าหมาย
                            {{item.targrt_Assess | number:'1.2-2'}}</p>
                          <div class="progress progress-sm">
                            <div class="progress-bar" [ngStyle]="{'width': item.pc_targrt_Assess+'%'}"></div>
                          </div>
                        </div>
                        <div class="icon">
                          <i class=" fas fa-sort-amount-up"></i>
                        </div>
                        <a class="small-box-footer">
                          จากการประเมินอ้อยของพนักงาน <i class="fas fa-user-edit"></i>
                        </a>
                      </div>
                    </div>
                    <div class="col-sm-5" style="text-align:center">
                      <div class="small-box bg-warning">
                        <div class="inner">
                          <h2 style="font-weight: bold;">{{item.Assess_left | number:'1.2-2'}}</h2>
                          <p style="font-weight: bold; color: #fff;">{{item.pc_targrt_Assess_left}}% จากเป้าหมาย
                            {{item.targrt_Assess | number:'1.2-2'}}</p>
                          <div class="progress progress-sm">
                            <div class="progress-bar" [ngStyle]="{'width': item.pc_targrt_Assess_left+'%'}"></div>
                          </div>
                        </div>
                        <div class="icon">
                          <i class=" fas fa-leaf"></i>
                        </div>
                        <a class="small-box-footer">
                          จากประเมินอ้อยหลังหักพื้นที่เสียหาย พันธ์ุอ้อยและตันอ้อยที่สูญเสีย
                        </a>
                      </div>
                    </div>
                    <div class="col"></div>
                    <!--<div class="col-12 col-sm-4" style="text-align:center">
                        <div class="small-box bg-danger">
                          <div class="inner">
                            <h2 style="font-weight: bold;">{{item.Assess_left2 | number:'1.2-2'}}</h2>
                            <p style="font-weight: bold; color: #fff;">{{item.pc_targrt_Assess_left2}}% จากเป้าหมาย
                              {{item.targrt_Assess | number:'1.2-2'}}</p>
                            <div class="progress progress-sm">
                              <div class="progress-bar" [ngStyle]="{'width': item.pc_targrt_Assess_left2+'%'}"></div>
                            </div>
                          </div>
                          <div class="icon">
                            <i class=" fas fa-leaf"></i>
                          </div>
                          <a href="#" class="small-box-footer">
                            จากประเมินอ้อยหลังหักพันธ์ุอ้อยและตันอ้อยที่สูญเสีย
                          </a>
                        </div>
                      </div>-->
                  </div>
                </div>

                <div class="card" *ngIf="chartOptions_ton">
                  <div echarts [options]="chartOptions_ton" class="chart-container"></div>
                </div>
                <!--<div class="card" style="align-items: center;">                 
                  <div id="ChartTypeMC" style="align-items: center; max-width: 1300px;max-height:700px;"></div>
                </div>-->

                <!-- 00 -->
                <div _ngcontent-ist-c251="" class="info-box">
                  <div class="card-body">
                    <table class="table table-striped" #table style="text-align:center">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>ชื่อ</th>
                          <th>เป้าหมายปริมาณอ้อย</th>
                          <!--
                              <th>คำนวณจากระบบ</th>
                              <th>%จากระบบ/เป้าหมาย</th>
                              <th>ส่วนต่างจากเป้าหมาย</th>-->

                          <th>จากนสสประเมิน</th>
                          <th>ปริมาณอ้อยหักเสียหาย</th>
                          <th>%นสสประเมิน/เป้าหมาย</th>
                          <th>ส่วนต่างจากเป้าหมาย</th>
                          <th>อ้อยเข้า</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let dt of listDataNow2;index as i" style="text-align:center">
                          <td>{{i+1}}</td>
                          <td style="text-align:left">{{dt.supname}}</td>
                          <td>{{dt.targrt_Assess | number:'1.2-2'}}</td>
                          <!--
                              <td>{{dt.Assess_b | number:'1.2-2'}}</td>
                              <td>{{dt.pc_targrt_Assess_b | number:'1.2-2'}}</td>
                              <td>{{dt.diff_Assess_b | number:'1.2-2'}}</td>-->

                          <td>{{dt.Assess | number:'1.2-2'}}</td>
                          <td>{{dt.Assess_left | number:'1.2-2'}}</td>
                          <td>{{dt.pc_targrt_Assess | number:'1.2-2'}}</td>
                          <td>{{dt.diff_Assess | number:'1.2-2'}}</td>
                          <td>{{dt.cane_in | number:'1.2-2'}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!-- 0 -->
            </div>

            <div class="tab-pane fade " id="vert-tabs-cane" role="tabpanel" aria-labelledby="vert-tabs-cane-tab">
              <!-- PA -->
              <div class="container-fluid">
                <div _ngcontent-ist-c251="" class="info-box">
                  <div class="card-body">
                    <div class="row mt-3">
                      <chart [type]="typeChart" [data]="dataChartPA" [options]="optionsChartPA" style="height: 600px;">
                      </chart>
                    </div>
                  </div>
                </div>
              </div>
              <!-- PA -->
            </div>

            <div class="tab-pane fade" id="vert-tabs-output" role="tabpanel" aria-labelledby="vert-tabs-output-tab">
              <!-- 2 -->
              <div class="container-fluid">
                <div class="row" *ngFor="let item of partlist">
                  <div class="col-12 col-sm-6 col-md-3" style="text-align:center">
                    <div class="info-box">
                      <span class="info-box-icon bg-info elevation-1">
                        <i class="fas fa-heart"></i>
                      </span>
                      <div class="info-box-content">
                        <span class="info-box-text">อ้อยปลายฝน <b class="text-green">{{item.pc_yield_er |
                            number:'1.2-2'}}</b>
                          %</span>
                        <div class="progress progress-sm">
                          <div class="progress-bar bg-primary" [ngStyle]="{'width': item.pc_yield_er+'%'}"></div>
                        </div>
                        <span class="info-box-number:'1.2-2'">
                          <b class="text-red">{{item.yield_target_ER | number:'1.2-2'}}</b>/<b
                            class="text-primary">{{item.yield_er | number:'1.2-2'}}</b>
                        </span>
                      </div>
                      <!-- /.info-box-content -->
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-3" style="text-align:center">
                    <div class="info-box">
                      <span class="info-box-icon bg-green elevation-1">
                        <i class="fas fa-heart"></i>
                      </span>
                      <div class="info-box-content">
                        <span class="info-box-text">อ้อยต้นฝน <b class="text-green">{{item.pc_yield_sr |
                            number:'1.2-2'}}</b>
                          %</span>
                        <div class="progress progress-sm">
                          <div class="progress-bar bg-primary" [ngStyle]="{'width': item.pc_yield_sr+'%'}"></div>
                        </div>
                        <span class="info-box-number">
                          <b class="text-red">{{item.yield_target_SR | number:'1.2-2'}}</b>/<b
                            class="text-primary">{{item.yield_sr | number:'1.2-2'}}</b>
                        </span>
                      </div>
                      <!-- /.info-box-content -->
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-3" style="text-align:center">
                    <div class="info-box">
                      <span class="info-box-icon bg-warning elevation-1">
                        <i class="fas fa-heart"></i>
                      </span>
                      <div class="info-box-content">
                        <span class="info-box-text">อ้อยตอ <b class="text-green">{{item.pc_yield_st |
                            number:'1.2-2'}}</b>
                          %</span>
                        <div class="progress progress-sm">
                          <div class="progress-bar bg-primary" [ngStyle]="{'width': item.pc_yield_st+'%'}"></div>
                        </div>
                        <span class="info-box-number">
                          <b class="text-red">{{item.yield_target_ST | number:'1.2-2'}}</b>/<b
                            class="text-primary">{{item.yield_st | number:'1.2-2'}}</b>
                        </span>
                      </div>
                      <!-- /.info-box-content -->
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-3" style="text-align:center">
                    <div class="info-box">
                      <span class="info-box-icon bg-danger elevation-1">
                        <i class="fas fa-heart"></i>
                      </span>
                      <div class="info-box-content">
                        <span class="info-box-text">อ้อยรวม <b class="text-green">{{item.pc_targrt_yield |
                            number}}</b> %</span>
                        <div class="progress progress-sm">
                          <div class="progress-bar bg-primary" [ngStyle]="{'width': item.pc_targrt_yield+'%'}"></div>
                        </div>
                        <span class="info-box-number">
                          <b class="text-red">{{item.targrt_yield | number:'1.2-2'}}</b>/<b
                            class="text-primary">{{item.yield_all | number:'1.2-2'}}</b>
                        </span>
                      </div>
                      <!-- /.info-box-content -->
                    </div>
                  </div>
                </div>
                <div _ngcontent-ist-c251="" class="info-box">
                  <div class="row mt-3">
                    <chart [type]="typeChart" [data]="dataChart2" [options]="optionsChart2"></chart>
                  </div>
                </div>
                <!-- 00 -->
                <div _ngcontent-ist-c251="" class="info-box">
                  <div class="card-body">
                    <table class="table table-striped" #table style="text-align:center">
                      <thead>
                        <tr>
                          <th></th>
                          <th>เป้าหมายผลผลิต</th>
                          <th>ผลผลิตที่ได้</th>
                          <th>%ผลผลิตที่ได้</th>
                          <th>เป้าปลายฝน</th>
                          <th>ผลผลิตปลายฝน</th>
                          <th>%เป้าปลายฝน</th>
                          <th>เป้าต้นฝน</th>
                          <th>ผลผลิตต้นฝน</th>
                          <th>%เป้าต้นฝน</th>
                          <th>เป้าอ้อยตอ</th>
                          <th>ผลผลิตอ้อยตอ</th>
                          <th>%เป้าอ้อยตอ</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let dt of listDataNow2" style="text-align:center">
                          <td>{{dt.supname}}</td>
                          <td>{{dt.targrt_yield}}</td>
                          <td>{{dt.yield_all}}</td>
                          <td>{{dt.pc_targrt_yield}}</td>
                          <td>{{dt.yield_target_ER}}</td>
                          <td>{{dt.yield_er}}</td>
                          <td>{{dt.pc_yield_er}}</td>
                          <td>{{dt.yield_target_SR}}</td>
                          <td>{{dt.yield_sr}}</td>
                          <td>{{dt.pc_yield_sr}}</td>
                          <td>{{dt.yield_target_ST}}</td>
                          <td>{{dt.yield_st}}</td>
                          <td>{{dt.pc_yield_st}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- 0 -->
              </div>
            </div>

            <div class="tab-pane fade " id="vert-tabs-ton" role="tabpanel" aria-labelledby="vert-tabs-ton-tab">
              <!-- 24 -->
              <div class="container-fluid">
                <div _ngcontent-ist-c251="" class="info-box">
                  <div class="card-body">
                    <div class="row mt-3">
                      <chart [type]="typeChart" [data]="dataChart23" [options]="optionsChart23" style="height: 600px;">
                      </chart>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 23 -->
            </div>

            <div class="tab-pane fade " id="vert-tabs-Assess" role="tabpanel" aria-labelledby="vert-tabs-Assess-tab">
              <!-- 24  -->
              <div class="container-fluid">
                <div _ngcontent-ist-c251="" class="info-box">
                  <div class="card-body">
                    <div class="row mt-3">
                      <chart [type]="typeChart" [data]="dataChart24" [options]="optionsChart24" style="height: 600px;">
                      </chart>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 24 -->
            </div>

            <div class="tab-pane fade" id="vert-tabs-yildAdd" role="tabpanel" aria-labelledby="vert-tabs-yildAdd-tab">
              <!-- 2.1 -->
              <div class="container-fluid">
                <div class="row">
                  <div class="row" *ngFor="let item of partlist">

                    <div class="col-12 col-sm-6 col-md-4">
                      <div class="info-box bg-gradient-warning">
                        <span class="info-box-icon"><i class="fa-user-check"></i></span>
                        <div class="info-box-content">
                          <span class="info-box-text">เทียบจำนวนโครงการ</span>
                          <span class="info-box-number">สำเร็จ {{item.sumcntSecPlan | number:'1.2-2'}} คงเหลือ
                            {{item.sumCntPlan | number:'1.2-2'}}</span>
                          <div class="progress">
                            <div class="progress-bar" [ngStyle]="{'width': item.pcsumcntSecPlan+'%'}"></div>
                          </div>
                          <span class="progress-description">
                            {{item.pcsumcntSecPlan | number:'1.2-2'}}% จาก {{item.sumCntPlan | number:'1.2-2'}} โครงการ
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-2">

                    </div>
                    <div class="col-12 col-sm-6 col-md-4">
                      <div class="info-box bg-success">
                        <span class="info-box-icon"><i class="far fa-thumbs-up"></i></span>
                        <div class="info-box-content">
                          <span class="info-box-text">ปริมาณอ้อยที่จะเพิ่มขึ้น</span>
                          <span class="info-box-number">++ {{item.sumTargPlan10 | number:'1.2-2'}} ตัน</span>
                          <div class="progress">
                            <div class="progress-bar" [ngStyle]="{'width': item.pcSumTargPlan10+'%'}"></div>
                          </div>
                          <span class="progress-description">
                            {{item.pcSumTargPlan10 | number:'1.2-2'}}% จากเดิม {{item.Assess | number:'1.2-2'}}
                            ที่ประเมิน
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-1">

                    </div>
                  </div>
                </div>

                <div _ngcontent-ist-c251="" class="info-box">
                  <div class="row mt-3">
                    <chart [type]="typeChart" [data]="dataChart2_1" [options]="optionsChart2_1" style="height: 600px;">
                    </chart>
                  </div>
                </div>
                <div _ngcontent-ist-c251="" class="info-box">
                  <div class="row mt-3">
                    <chart [type]="typeChart" [data]="dataChart2_2" [options]="optionsChart2_2" style="height: 600px;">
                    </chart>
                  </div>
                </div>

              </div>
            </div>
            <div class="tab-pane fade" id="vert-tabs-area" role="tabpanel" aria-labelledby="vert-tabs-area-tab">
              <!-- 3 -->
              <div class="container-fluid">
                <div class="row" *ngFor="let item of partlist">
                  <div class="col-12 col-sm-6 col-md-3" style="text-align:center">
                    <div class="info-box">
                      <div class="info-box-content">
                        <span class="info-box-text">อ้อยปลายฝน <b class="text-green">{{item.pc_areas_er |
                            number:'1.2-2'}}</b>
                          %</span>
                        <div class="progress progress-sm">
                          <div class="progress-bar bg-success" [ngStyle]="{'width': item.pc_areas_er+'%'}"></div>
                        </div>
                        <span class="info-box-text"><b class="text-success">{{item.areas_er |
                            number}}</b>/<b>{{item.target_ER | number:'1.2-2'}}</b> ไร่</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-sm-6 col-md-3" style="text-align:center">
                    <div class="info-box">
                      <div class="info-box-content">
                        <span class="info-box-text">อ้อยต้นฝน <b class="text-green">{{item.pc_areas_sr |
                            number:'1.2-2'}}</b>
                          %</span>
                        <div class="progress progress-sm">
                          <div class="progress-bar bg-primary" [ngStyle]="{'width': item.pc_areas_sr+'%'}"></div>
                        </div>
                        <span class="info-box-text"><b class="text-primary">{{item.target_SR |
                            number}}</b>/<b>{{item.areas_sr | number:'1.2-2'}}</b> ไร่</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-sm-6 col-md-3" style="text-align:center">
                    <div class="info-box">
                      <div class="info-box-content">
                        <span class="info-box-text">อ้อยตอ <b class="text-green">{{item.pc_areas_yst |
                            number:'1.2-2'}}</b>
                          %</span>
                        <div class="progress progress-sm">
                          <div class="progress-bar bg-warning" [ngStyle]="{'width': item.pc_areas_yst+'%'}"></div>
                        </div>
                        <span class="info-box-text"><b class="text-warning">{{item.target_ST |
                            number}}</b>/<b>{{item.areasY_st | number:'1.2-2'}}</b> ไร่</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-sm-6 col-md-3" style="text-align:center">
                    <div class="info-box">
                      <div class="info-box-content">
                        <span class="info-box-text">พื้นที่อ้อยทั้งหมด <b class="text-green">{{item.pc_areas |
                            number}}</b> %</span>
                        <div class="progress progress-sm">
                          <div class="progress-bar bg-danger" [ngStyle]="{'width': item.pc_areas+'%'}"></div>
                        </div>
                        <span class="info-box-text"><b class="text-danger">{{item.landvalue |
                            number}}</b>/<b>{{item.sum_areas | number:'1.2-2'}}</b> ไร่</span>
                      </div>
                    </div>
                  </div>

                  <!--
                            <div class="progress-group">
                              พื้นที่อ้อยหักพื้นที่เสียหาย {{item.pc_areas_left}} %
                              <span class="float-right"><b>{{item.landvalue_left | number:'1.2-2'}}</b>/{{item.sum_areas | number:'1.2-2'}} </span>
                              <div class="progress progress-sm">
                                <div class="progress-bar bg-warning"  [ngStyle]="{'width': item.pc_areas_left+'%'}"></div>
                              </div>
                            </div>
                          -->
                </div>

                <div _ngcontent-ist-c251="" class="info-box">
                  <div class="row mt-3">
                    <chart [type]="typeChart" [data]="dataChart3" [options]="optionsChart3" style="height: 600px;">
                    </chart>
                  </div>
                </div>
                <!-- 00 -->
                <div _ngcontent-ist-c251="" class="info-box">
                  <div class="card-body">
                    <table class="table table-striped" #table>
                      <thead>
                        <tr style="text-align:center">
                          <th></th>
                          <th>เป้าหมายพื้นที่</th>
                          <th>พื้นที่ปัจจุบัน</th>
                          <th>%ผลผลิตที่ได้</th>
                          <th>เป้าปลายฝน</th>
                          <th>พื้นที่ปลายฝน</th>
                          <th>%เป้าปลายฝน</th>
                          <th>เป้าต้นฝน</th>
                          <th>พื้นที่ต้นฝน</th>
                          <th>%เป้าต้นฝน</th>
                          <th>เป้าอ้อยตอ</th>
                          <th>พื้นที่อ้อยตอ</th>
                          <th>%เป้าอ้อยตอ</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let dt of listDataNow2">
                          <td>{{dt.supname}}</td>
                          <td>{{dt.sum_areas | number:'1.2-2'}}</td>
                          <td>{{dt.landvalue | number:'1.2-2'}}</td>
                          <td>{{dt.pc_areas | number:'1.2-2'}}</td>
                          <td>{{dt.target_ER | number:'1.2-2'}}</td>
                          <td>{{dt.areas_er | number:'1.2-2'}}</td>
                          <td>{{dt.pc_areas_er | number:'1.2-2'}}</td>
                          <td>{{dt.target_SR | number:'1.2-2'}}</td>
                          <td>{{dt.areas_sr | number:'1.2-2'}}</td>
                          <td>{{dt.pc_areas_sr | number:'1.2-2'}}</td>
                          <td>{{dt.target_ST | number:'1.2-2'}}</td>
                          <td>{{dt.areasY_st | number:'1.2-2'}}</td>
                          <td>{{dt.pc_areas_yst | number:'1.2-2'}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- 0 -->
              </div>
            </div>
            <div class="tab-pane fade " id="vert-tabs-job" role="tabpanel" aria-labelledby="vert-tabs-job-tab">
              <!-- job -->
              <div class="container-fluid">
                <!--
                        <div class="row col-md-6" *ngFor="let item of partlist">                              
                          <div class="col-12 col-sm-8 col-md-6">
                            <div class="progress-group">
                              อ้อยปลายฝน {{item.pc_areas_er}} %
                              <span class="float-right"><b>{{item.areas_er | number:'1.2-2'}}</b>/{{item.target_ER | number:'1.2-2'}}</span>
                              <div class="progress progress-sm">
                                <div class="progress-bar bg-primary" [ngStyle]="{'width': item.pc_areas_er+'%'}"></div>
                              </div>
                            </div>
                          </div>
                        </div>-->
                <div _ngcontent-ist-c251="" class="info-box">
                  <div class="card-body">
                    <div class="row mt-3">
                      <chart [type]="typeChart" [data]="dataChartP" [options]="optionsChartP" style="height: 600px;">
                      </chart>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="tab-pane fade " id="vert-tabs-update" role="tabpanel" aria-labelledby="vert-tabs-update-tab">
              <!-- update -->
              <div class="container-fluid">
                <div _ngcontent-ist-c251="" class="info-box">
                  <div class="card-body">
                    <div class="row mt-3">
                      <chart [type]="typeChart" [data]="dataChartUp" [options]="optionsChartUp" style="height: 600px;">
                      </chart>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="tab-pane fade " id="vert-tabs-dindan" role="tabpanel" aria-labelledby="vert-tabs-dindan-tab">
              <!-- 4 -->
              <div class="container-fluid">

                <div class="row col-md-6" *ngFor="let item of partlist">
                  <div class="info-box bg-info">
                    <span class="info-box-icon"><i class="fas fa-tractor"></i></span>

                    <div class="info-box-content">
                      <span class="info-box-text">ระเบิดดาน </span>
                      <span class="info-box-number">{{item.hardSoilBlast | number:'1.2-2'}} </span>

                      <div class="progress">
                        <div class="progress-bar" [ngStyle]="{'width': item.pc_hardSoilBlast +'%'}"></div>
                      </div>
                      <span class="progress-description">
                        {{item.pc_hardSoilBlast | number:'1.2-2'}} % ของแปลงอ้อยปลูกใหม่ {{item.tg_landvalue_New_Y |
                        number:'1.2-2'}}
                        ไร่
                      </span>
                    </div>
                    <!-- /.info-box-content -->
                  </div>
                </div>
                <div _ngcontent-ist-c251="" class="info-box">
                  <div class="card-body">
                    <div class="row mt-3">
                      <chart [type]="typeChart" [data]="dataChart4" [options]="optionsChart4" style="height: 600px;">
                      </chart>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="vert-tabs-canetype" role="tabpanel" aria-labelledby="vert-tabs-canetype-tab">
              <!-- 5 -->
              <div class="card">
                <div class="card-body">
                  <table class="table table-striped">
                    <thead>
                      <tr style="text-align:center">
                        <td>ชื่อพันธุ์</td>
                        <td class="text-center">จำนวนแปลง</td>
                        <td class="text-center">พื้นที่ปลูก</td>
                        <td class="text-center">พื้นที่ปลูกในปีการผลิต</td>
                        <td class="text-center">% พื้นที่ปลูก</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of canetype" style="text-align:center">
                        <td>{{item.seedname}}</td>
                        <td class="text-center">{{item.cnt | number:'1.2-2'}}</td>
                        <td class="text-center">{{item.landvalue | number:'1.2-2'}}</td>
                        <td class="text-center">{{item.areaY | number:'1.2-2'}}</td>
                        <td class="text-center">{{item.pc_per_areaY | number:'1.2-2'}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

            </div>
            <div class="tab-pane fade" id="vert-tabs-rangland" role="tabpanel" aria-labelledby="vert-tabs-rangland-tab">
              <!-- 6 -->
              <div class="row">
                <div class="row" *ngFor="let item of partlist">
                  <div class="col-12 col-sm-6 col-md-5">
                    <div class="info-box bg-gradient-warning">
                      <span class="info-box-icon"></span>
                      <div class="info-box-content">
                        <span class="info-box-text">ระยะร่อง มากกว่า 1.5 ม. </span>
                        <span class="info-box-number">{{item.Groove15| number:'1.2-2'}} ไร่</span>
                        <div class="progress">
                          <div class="progress-bar" [ngStyle]="{'width': item.pc_Groove15+'%'}"></div>
                        </div>
                        <span class="progress-description">
                          {{item.pc_Groove15 | number:'1.2-2'}}% ของแปลงอ้อยปลูกใหม่ {{item.landvalue_SR_Y |
                          number:'1.2-2'}} ไร่
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-1"> </div>

                  <div class="col-12 col-sm-6 col-md-5">
                    <div class="info-box bg-success">
                      <span class="info-box-icon"></span>
                      <div class="info-box-content">
                        <span class="info-box-text">ระยะร่อง มากกว่า 1.6 ม. </span>
                        <span class="info-box-number">{{item.Groove16| number:'1.2-2'}} ไร่</span>
                        <div class="progress">
                          <div class="progress-bar" [ngStyle]="{'width': item.pc_Groove16+'%'}"></div>
                        </div>
                        <span class="progress-description">
                          {{item.pc_Groove16 | number:'1.2-2'}}% ของแปลงอ้อยปลูกใหม่ {{item.landvalue_SR_Y |
                          number:'1.2-2'}} ไร่
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /.info-box-content -->
                <div _ngcontent-ist-c251="" class="info-box">
                  <div class="card-body">
                    <div class="row mt-3">
                      <chart [type]="typeChart" [data]="dataChart6" [options]="optionsChart6" style="height: 600px;">
                      </chart>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div class="tab-pane fade " id="vert-tabs-chame1" role="tabpanel" aria-labelledby="vert-tabs-chame1-tab">
              <!-- 7 -->
              <div class="container-fluid">
                <div class="row col-md-6" *ngFor="let item of partlist">
                  <div class="info-box bg-info">
                    <span class="info-box-icon"><i class=" fa fa-leaf"></i></span>

                    <div class="info-box-content">
                      <span class="info-box-text">ใส่ปุ๋ยเคมี 1 ภายใน 7 วัน</span>
                      <span class="info-box-number">{{item.FertilizerRound1 | number:'1.2-2'}} ไร่</span>

                      <div class="progress">
                        <div class="progress-bar" [ngStyle]="{'width': item.pc_FertilizerRound1 + '%'}"></div>
                      </div>
                      <span class="progress-description">
                        {{item.pc_FertilizerRound1 | number:'1.2-2'}} % ของแปลงอ้อยปลูกใหม่ {{item.landvalue |
                        number:'1.2-2'}} ไร่
                      </span>
                    </div>
                    <!-- /.info-box-content -->
                  </div>
                </div>
                <div _ngcontent-ist-c251="" class="info-box">
                  <div class="card-body">
                    <div class="row mt-3">
                      <chart [type]="typeChart" [data]="dataChart7" [options]="optionsChart7" style="height: 600px;">
                      </chart>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="vert-tabs-chame2" role="tabpanel" aria-labelledby="vert-tabs-chame2-tab">
              <!-- 8 -->
              <div class="container-fluid">
                <div class="row col-md-6" *ngFor="let item of partlist">
                  <div class="info-box bg-info">
                    <span class="info-box-icon"><i class="fa fa-leaf"></i></span>

                    <div class="info-box-content">
                      <span class="info-box-text">ใส่ปุ๋ยเคมี 2 ภายใน 45 วัน</span>
                      <span class="info-box-number">{{item.FertilizerRound2 | number:'1.2-2'}} ไร่</span>

                      <div class="progress">
                        <div class="progress-bar" [ngStyle]="{'width': item.pc_FertilizerRound2+'%'}"></div>
                      </div>
                      <span class="progress-description">
                        {{item.pc_FertilizerRound2}}% ของแปลงอ้อยปลูกใหม่ {{item.landvalue}} ไร่
                      </span>
                    </div>
                    <!-- /.info-box-content -->
                  </div>
                </div>
                <div _ngcontent-ist-c251="" class="info-box">
                  <div class="card-body">
                    <div class="row mt-3">
                      <chart [type]="typeChart" [data]="dataChart8" [options]="optionsChart8" style="height: 600px;">
                      </chart>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="vert-tabs-chame3" role="tabpanel" aria-labelledby="vert-tabs-chame3-tab">
              <!-- 9 -->
              <div class="container-fluid">
                <div class="row col-md-6" *ngFor="let item of partlist">
                  <div class="info-box bg-info">
                    <span class="info-box-icon"><i class=" fa fa-leaf"></i></span>

                    <div class="info-box-content">
                      <span class="info-box-text">ใส่ปุ๋ยเคมี 3 ภายใน 90 วัน </span>
                      <span class="info-box-number">{{item.FertilizerRound3 | number:'1.2-2'}} ไร่</span>

                      <div class="progress">
                        <div class="progress-bar" [ngStyle]="{'width': item.pc_FertilizerRound3+'%'}"></div>
                      </div>
                      <span class="progress-description">
                        {{item.pc_FertilizerRound3}}% ของแปลงอ้อยปลูกใหม่ {{item.area_ton15 | number:'1.2-2'}} ไร่
                      </span>
                    </div>
                    <!-- /.info-box-content -->
                  </div>
                </div>
                <div _ngcontent-ist-c251="" class="info-box">
                  <div class="card-body">
                    <div class="row mt-3">
                      <chart [type]="typeChart" [data]="dataChart9" [options]="optionsChart9" style="height: 600px;">
                      </chart>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="tab-pane fade " id="vert-tabs-ferti" role="tabpanel" aria-labelledby="vert-tabs-ferti-tab">
              <!-- 10 -->

              <div class="row" *ngFor="let item of partlist">
                <div _ngcontent-ist-c251="" class="info-box">
                  <div class="card-body">
                    <div class="col-12 col-sm-6 col-md-6">

                      <div class="info-box bg-info">
                        <span class="info-box-icon"><i class=" fa fa-leaf"></i></span>

                        <div class="info-box-content">
                          <span class="info-box-text">ใส่อินทรีย์อ้อยปลูกใหม่</span>
                          <span class="info-box-number">{{item.NaturalFerti_n | number:'1.2-2'}} ไร่</span>

                          <div class="progress">
                            <div class="progress-bar" [ngStyle]="{'width': item.pcNaturalFerti_n+'%'}"></div>
                          </div>
                          <span class="progress-description">
                            {{item.pcNaturalFerti_n | number:'1.2-2'}} % ของแปลงอ้อยปลูกใหม่ {{item.tg_landvalue_New_Y |
                            number}} ไร่
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-2"></div>

                    <!-- /.info-box-content -->

                    <div class="row mt-3">

                      <chart [type]="typeChart" [data]="dataChart10" [options]="optionsChart10" style="height: 600px;">
                      </chart>
                    </div>
                  </div>
                </div>
                <div _ngcontent-ist-c251="" class="info-box">
                  <div class="card-body">
                    <div class="row" *ngFor="let item of partlist">
                      <div class="col-12 col-sm-6 col-md-4">
                        <div class="info-box bg-gradient-warning">
                          <span class="info-box-icon"></span>
                          <div class="info-box-content">
                            <span class="info-box-text">ใส่อินทรีย์ทั้งหมด</span>
                            <span class="info-box-number">{{item.NaturalFerti_a| number:'1.2-2'}} ไร่</span>

                            <div class="progress">
                              <div class="progress-bar" [ngStyle]="{'width': item.pcNaturalFerti_a+'%'}"></div>
                            </div>
                            <span class="progress-description">
                              {{item.pcNaturalFerti_a | number:'1.2-2'}}% ของแปลงอ้อยทั้งหมด {{item.landvalue |
                              number:'1.2-2'}} ไร่
                            </span>
                          </div>
                        </div>
                      </div>

                      <chart [type]="typeChart" [data]="dataChart101" [options]="optionsChart101"
                        style="height: 600px;"></chart>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div class="tab-pane fade" id="vert-tabs-dolomite" role="tabpanel" aria-labelledby="vert-tabs-dolomite-tab">
              <!-- 11 -->
              <div class="container-fluid">
                <div class="row" *ngFor="let item of partlist">
                  <div _ngcontent-ist-c251="" class="info-box">
                    <div class="card-body">
                      <div class="col-12 col-sm-6 col-md-6">
                        <div class="info-box bg-info">
                          <span class="info-box-icon"><i class="fa fa-leaf"></i></span>

                          <div class="info-box-content">
                            <span class="info-box-text">ใส่โดโลไมท์อ้อยปลูกใหม่ </span>
                            <span class="info-box-number">{{item.AmountDolomite_n | number:'1.2-2'}} ไร่</span>

                            <div class="progress">
                              <div class="progress-bar" [ngStyle]="{'width': item.pc_AmountDolomite_n+'%'}"></div>
                            </div>
                            <span class="progress-description">
                              {{item.pc_AmountDolomite_n | number:'1.2-2'}}% ของอ้อยปลูกใหม่ {{item.landvalue_new |
                              number:'1.2-2'}}
                              ไร่
                            </span>
                          </div>
                        </div>
                      </div>
                      <chart [type]="typeChart" [data]="dataChart11" [options]="optionsChart11" style="height: 600px;">
                      </chart>

                    </div>
                  </div>

                  <!-- /.info-box-content -->

                </div>
                <div class="row" *ngFor="let item of partlist">
                  <div _ngcontent-ist-c251="" class="info-box">
                    <div class="card-body">
                      <div class="col-12 col-sm-6 col-md-6">
                        <div class="info-box bg-gradient-warning">
                          <span class="info-box-icon"></span>
                          <div class="info-box-content">
                            <span class="info-box-text">ใส่โดโลไมท์อ้อยทั้งหมด</span>
                            <span class="info-box-number">{{item.AmountDolomite_a| number:'1.2-2'}} ไร่</span>

                            <div class="progress">
                              <div class="progress-bar" [ngStyle]="{'width': item.pc_AmountDolomite_a+'%'}"></div>
                            </div>
                            <span class="progress-description">
                              {{item.pc_AmountDolomite_a | number:'1.2-2'}}% ของอ้อยอ้อยทั้งหมด {{item.landvalue |
                              number:'1.2-2'}}
                              ไร่
                            </span>
                          </div>
                        </div>
                      </div>
                      <chart [type]="typeChart" [data]="dataChart111" [options]="optionsChart111"
                        style="height: 600px;"></chart>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="tab-pane fade" id="vert-tabs-rategrow" role="tabpanel" aria-labelledby="vert-tabs-rategrow-tab">
              <!-- 12 -->
              <div class="container-fluid">
                <div class="row" *ngFor="let item of partlist">
                  <div class="col-12 col-sm-6 col-md-5">
                    <div class="info-box bg-info">
                      <span class="info-box-icon"><i class="fa fa-leaf"></i></span>

                      <div class="info-box-content">
                        <span class="info-box-text">% การงอก >90 </span>
                        <span class="info-box-number">{{item.GerminationPercent90 | number:'1.2-2'}} ไร่</span>

                        <div class="progress">
                          <div class="progress-bar" [ngStyle]="{'width': item.pc_GerminationPercent90+'%'}"></div>
                        </div>
                        <span class="progress-description">
                          {{item.pc_GerminationPercent90 | number:'1.2-2'}}% ของอ้อยปลูกใหม่ {{item.landvalue_new |
                          number:'1.2-2'}}
                          ไร่
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-1"> </div>

                  <div class="col-12 col-sm-6 col-md-5">
                    <div class="info-box bg-gradient-warning">
                      <span class="info-box-icon"></span>
                      <div class="info-box-content">
                        <span class="info-box-text">% การงอก >95</span>
                        <span class="info-box-number">{{item.GerminationPercent95| number:'1.2-2'}} ไร่</span>

                        <div class="progress">
                          <div class="progress-bar" [ngStyle]="{'width': item.pc_GerminationPercent95+'%'}"></div>
                        </div>
                        <span class="progress-description">
                          {{item.pc_GerminationPercent95 | number:'1.2-2'}}% ของอ้อยปลูกใหม่ {{item.landvalue_new |
                          number:'1.2-2'}}
                          ไร่
                        </span>
                      </div>
                    </div>
                  </div>
                  <div _ngcontent-ist-c251="" class="info-box">
                    <div class="card-body">
                      <chart [type]="typeChart" [data]="dataChart12" [options]="optionsChart12" style="height: 600px;">
                      </chart>

                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="tab-pane fade " id="vert-tabs-weed" role="tabpanel" aria-labelledby="vert-tabs-weed-tab">
              <!-- 13 -->
              <div class="container-fluid">
                <div class="row col-md-6" *ngFor="let item of partlist">
                  <div class="info-box bg-info">
                    <span class="info-box-icon"><i class="fa fa-leaf"></i></span>

                    <div class="info-box-content">
                      <span class="info-box-text">ไม่มีวัชพืช </span>
                      <span class="info-box-number">{{item.lastweet | number:'1.2-2'}} ไร่</span>

                      <div class="progress">
                        <div class="progress-bar" [ngStyle]="{'width': item.pc_lastweet+'%'}"></div>
                      </div>
                      <span class="progress-description">
                        {{item.pc_lastweet| number:'1.2-2'}} % ของอ้อยปลูกใหม่ {{item.landvalue| number:'1.2-2'}} ไร่
                      </span>
                    </div>
                    <!-- /.info-box-content -->
                  </div>
                </div>
                <div class="row mt-3">
                  <chart [type]="typeChart" [data]="dataChart13" [options]="optionsChart13" style="height: 600px;">
                  </chart>
                </div>
              </div>
            </div>
            <div class="tab-pane fade " id="vert-tabs-bug" role="tabpanel" aria-labelledby="vert-tabs-bug-tab">
              <!-- 14  -->
              <p>ยังไม่มีเนื้อหานี้ในตอนนี้</p>
            </div>
            <div class="tab-pane fade" id="vert-tabs-base" role="tabpanel" aria-labelledby="vert-tabs-base-tab">
              <!-- 15  -->
              <p>ยังไม่มีเนื้อหานี้ในตอนนี้</p>
            </div>
            <div class="tab-pane fade" id="vert-tabs-fmgrade" role="tabpanel" aria-labelledby="vert-tabs-fmgrade-tab">
              <!-- 16 -->
              <div class="container-fluid" *ngFor="let item of partlist">
                <div class="row">
                  <div class="col-12 col-sm-6 col-md-3">
                    <div class="small-box bg-warning">
                      <div class="inner">
                        <h3>{{item.cnt_fm | number:'1.2-2'}}</h3>

                        <p>จำนวนชาวไร่</p>
                      </div>
                      <div class="icon">
                        <i class="fas fa-user-plus"></i>
                      </div>
                      <a href="#" class="small-box-footer">
                        More info <i class="fas fa-arrow-circle-right"></i>
                      </a>
                    </div>
                  </div>

                  <div class="col-12 col-sm-6 col-md-3">
                    <div class="info-box bg-success">
                      <span class="info-box-icon"><i class="fas fa-user-check"></i></span>

                      <div class="info-box-content">
                        <span class="info-box-text">เกรด A </span>
                        <span class="info-box-number">{{item.score_A}} ราย</span>

                        <div class="progress">
                          <div class="progress-bar" [ngStyle]="{'width': item.pc_score_A +'%'}"></div>
                        </div>
                        <span class="progress-description">
                          {{item.pc_score_A }}%
                        </span>
                      </div>
                      <!-- /.info-box-content -->
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-3">
                    <div class="info-box bg-warning">
                      <span class="info-box-icon"><i class="fas fa-user-check"></i></span>

                      <div class="info-box-content">
                        <span class="info-box-text">เกรด B </span>
                        <span class="info-box-number">{{item.score_B}} ราย</span>

                        <div class="progress">
                          <div class="progress-bar" [ngStyle]="{'width': item.pc_score_B +'%'}"></div>
                        </div>
                        <span class="progress-description">
                          {{item.pc_score_B }}%
                        </span>
                      </div>
                      <!-- /.info-box-content -->
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-3">
                    <div class="info-box bg-danger">
                      <span class="info-box-icon"><i class="fas fa-user-check"></i></span>

                      <div class="info-box-content">
                        <span class="info-box-text">เกรด C </span>
                        <span class="info-box-number">{{item.score_C}} ราย</span>

                        <div class="progress">
                          <div class="progress-bar" [ngStyle]="{'width': item.pc_score_C +'%'}"></div>
                        </div>
                        <span class="progress-description">
                          {{item.pc_score_C }}%
                        </span>
                      </div>
                      <!-- /.info-box-content -->
                    </div>
                  </div>
                </div>

                <div class="row mt-3">
                  <chart [type]="typeChart" [data]="dataChart16" [options]="optionsChart16" style="height: 600px;">
                  </chart>
                </div>
              </div>
            </div>
            <div class="tab-pane fade " id="vert-tabs-finance" role="tabpanel" aria-labelledby="vert-tabs-finance-tab">
              <!-- 17 -->
              <!-- 1 -->
              <div class="container-fluid" *ngFor="let item of partlist">
                <div class="row">
                  <!-- /.info-box-content -->
                  <div _ngcontent-ist-c251="" class="info-box">
                    <div class="card-body">
                      <div class="row" style="margin-top: 10px;">
                        <div class="col"></div>
                        <div class="col-2">
                          <div class="info-box bg-info">
                            <div class="info-box-content">
                              <span class="info-box-text">จ่ายเงินส่งเสริมทั้งหมด </span>
                              <span class="info-box-number">{{item.sum_money_amt | number:'1.2-2'}} บาท</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-2">
                          <div class="info-box bg-green">
                            <div class="info-box-content">
                              <span class="info-box-text">พื้นที่ขอเงินส่งเสริมทั้งหมด </span>
                              <span class="info-box-number">{{item.sum_area_amt | number:'1.2-2'}} ไร่</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-2">
                          <div class="info-box bg-warning">
                            <div class="info-box-content">
                              <span class="info-box-text">วงเงินส่งเสริม บาท/ไร่ </span>
                              <span class="info-box-number">{{item.sum_money_per_amt | number:'1.2-2'}} บาท/ไร่</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-2">
                          <div class="info-box bg-secondary">
                            <div class="info-box-content">
                              <span class="info-box-text">วงเงินส่งเสริม บาท/ตัน </span>
                              <span class="info-box-number">{{item.sum_money_per_ton | number:'1.2-2'}} บาท/ตัน</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-2">
                          <div class="info-box bg-dark">
                            <div class="info-box-content">
                              <span class="info-box-text">วงเงินส่งเสริม บาท/ตัน ทั้งหมด</span>
                              <span class="info-box-number">{{item.sum_money_per_tonAll | number:'1.2-2'}}
                                บาท/ตัน</span>
                            </div>
                          </div>
                        </div>
                        <div class="col"></div>
                      </div>
                      <div class="row mt-3">
                        <chart [type]="typeChart" [data]="dataChart20" [options]="optionsChart20"
                          style="height: 600px;"></chart>
                      </div>
                      <table class="table table-striped" #table>
                        <thead>
                          <tr style="text-align:center">
                            <th></th>

                            <th>จ่ายเงินส่งเสริมทั้งหมด</th>

                            <th>พื้นที่ขอเงินส่งเสริมทั้งหมด</th>
                            <th>วงเงินส่งเสริม บาท/ไร่</th>
                            <th>วงเงินส่งเสริม บาท/ตัน</th>
                            <th>วงเงินส่งเสริม บาท/ตัน ทั้งหมด</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let dt of listDataNow2" style="text-align:center">
                            <td>{{dt.supname}}</td>

                            <td>{{dt.sum_money_amt | number:'1.2-2'}}</td>

                            <td>{{dt.sum_area_amt | number:'1.2-2'}}</td>

                            <td>{{dt.sum_money_per_amt | number:'1.2-2'}}</td>
                            <td>{{dt.sum_money_per_ton | number:'1.2-2'}}</td>
                            <td>{{dt.sum_money_per_tonAll | number:'1.2-2'}}</td>
                          </tr>

                        </tbody>
                      </table>
                    </div>
                  </div>
                  <!-- /.info-box-content -->
                  <div _ngcontent-ist-c251="" class="info-box">
                    <div class="card-body">
                      <div class="row" style="margin-top: 10px;">
                        <div class="col-4">
                          <div class="info-box bg-info">
                            <div class="info-box-content">
                              <span class="info-box-text">จ่ายเงินส่งเสริมอ้อยใหม่ </span>
                              <span class="info-box-number">{{item.sum_money_amtNew | number:'1.2-2'}} บาท</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-4">
                          <div class="info-box bg-green">
                            <div class="info-box-content">
                              <span class="info-box-text">พื้นที่ขอเงินส่งเสริมอ้อยใหม่ </span>
                              <span class="info-box-number">{{item.sum_area_amtNew | number:'1.2-2'}} ไร่</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-4">
                          <div class="info-box bg-warning">
                            <div class="info-box-content">
                              <span class="info-box-text">วงเงินส่งเสริม/ไร่ </span>
                              <span class="info-box-number">{{item.sum_money_per_amtNew | number:'1.2-2'}}
                                บาท/ไร่</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-3">
                        <chart [type]="typeChart" [data]="dataChart21" [options]="optionsChart21"
                          style="height: 600px;"></chart>
                      </div>


                      <table class="table table-striped" #table>
                        <thead>
                          <tr style="text-align:center">
                            <th></th>
                            <th>จ่ายเงินส่งเสริมอ้อยใหม่</th>
                            <th>พื้นที่ขอเงินส่งเสริมอ้อยใหม่</th>
                            <th>วงเงินส่งเสริม/ไร่อ้อยใหม่</th>

                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let dt of listDataNow2" style="text-align:center">
                            <td>{{dt.supname}}</td>
                            <td>{{dt.sum_money_amtNew | number:'1.2-2'}}</td>
                            <td>{{dt.sum_area_amtNew | number:'1.2-2'}}</td>
                            <td>{{dt.sum_money_per_amtNew | number:'1.2-2'}}</td>
                          </tr>

                        </tbody>
                      </table>
                    </div>
                  </div>
                  <!-- /.info-box-content -->
                  <div _ngcontent-ist-c251="" class="info-box">
                    <div class="card-body">
                      <div class="row" style="margin-top: 10px;">
                        <div class="col-4">
                          <div class="info-box bg-info">
                            <div class="info-box-content">
                              <span class="info-box-text">จ่ายเงินส่งเสริมอ้อยตอ </span>
                              <span class="info-box-number">{{item.sum_money_amtST | number:'1.2-2'}} บาท</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-4">
                          <div class="info-box bg-green">
                            <div class="info-box-content">
                              <span class="info-box-text">พื้นที่ขอเงินส่งเสริมอ้อยตอ </span>
                              <span class="info-box-number">{{item.sum_area_amtST | number:'1.2-2'}} ไร่</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-4">
                          <div class="info-box bg-warning">
                            <div class="info-box-content">
                              <span class="info-box-text">วงเงินส่งเสริม/ไร่ </span>
                              <span class="info-box-number">{{item.sum_money_per_amtST | number:'1.2-2'}} บาท/ไร่</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-3">
                        <chart [type]="typeChart" [data]="dataChart22" [options]="optionsChart22"
                          style="height: 600px;"></chart>
                      </div>

                      <table class="table table-striped" #table>
                        <thead>
                          <tr style="text-align:center">
                            <th></th>
                            <th>จ่ายเงินส่งเสริมอ้อยตอ</th>
                            <th>พื้นที่ขอเงินส่งเสริมอ้อยตอ</th>
                            <th>วงเงินส่งเสริม/ไร่อ้อยตอ</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let dt of listDataNow2" style="text-align:center">
                            <td>{{dt.supname}}</td>
                            <td>{{dt.sum_money_amtST | number:'1.2-2'}}</td>
                            <td>{{dt.sum_area_amtST | number:'1.2-2'}}</td>
                            <td>{{dt.sum_money_per_amtST | number:'1.2-2'}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <!-- /.info-box-content
                            <div class="col-6">
                              <div class="info-box bg-info">
                                <span class="info-box-icon"><i class="fa fa-leaf" ></i></span>
                                  <div class="info-box-content">
                                    <span class="info-box-text">อ้อยปลูกใหม่จ่ายเงินส่งเสริม </span>
                                    <span class="info-box-number">{{item.landvalue_new | number:'1.2-2'}} ไร่</span>

                                    <div class="progress">
                                      <div class="progress-bar" [ngStyle]="{'width': item.pclandvalue_new +'%'}"></div>
                                    </div>
                                    <span class="progress-description">
                                      {{item.pclandvalue_new | number:'1.2-2'}} % ของอ้อยปลูกใหม่ {{item.tg_landvalue_New_Y | number:'1.2-2'}} ไร่
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row mt-3" style="margin-bottom: 20px;">
                              <chart [type]="typeChart" [data]="dataChart17"  [options]="optionsChart17" style="height: 600px;"></chart>
                            </div>
                          info-box-content 
                          -->

                  <!-- 2 -->
                  <div class="row" style="margin-top: 10px;">
                    <div class="col-6">
                      <div class="info-box bg-info">
                        <span class="info-box-icon"><i class="fas fa-align-justify"></i></span>

                        <div class="info-box-content">
                          <span class="info-box-text">อ้อยขอวงเงิน 6,000 ยังไม่ปลูก</span>
                          <span class="info-box-number">{{item.landvalue_P | number:'1.2-2'}} ไร่</span>

                          <div class="progress">
                            <div class="progress-bar" [ngStyle]="{'width': item.pclandvalue_P +'%'}"></div>
                          </div>
                          <span class="progress-description">
                            {{item.pclandvalue_P | number:'1.2-2'}} % ของแปลงที่ขอวงเงิน 6 พัน {{item.tg_landvalue_new |
                            number}} ไร่
                          </span>
                        </div>
                        <!-- /.info-box-content -->
                      </div>
                    </div>
                  </div>
                  <div class="row mt-3" style="margin-bottom: 20px;">
                    <chart [type]="typeChart" [data]="dataChart18" [options]="optionsChart18" style="height: 600px;">
                    </chart>
                  </div>

                  <!-- 3 -->
                  <div class="row" style="margin-top: 10px;">
                    <div class="col-6">
                      <div class="info-box bg-info">
                        <span class="info-box-icon"><i class="fa fa-leaf"></i></span>

                        <div class="info-box-content">
                          <span class="info-box-text">อ้อยขอวงเงิน 6,000 ทำครบตามกิจกรรม</span>
                          <span class="info-box-number">{{item.landvalue_Pa | number:'1.2-2'}} ไร่</span>

                          <div class="progress">
                            <div class="progress-bar" [ngStyle]="{'width': item.pclandvalue_Pa +'%'}"></div>
                          </div>
                          <span class="progress-description">
                            {{item.pclandvalue_Pa | number:'1.2-2'}} % ของแปลงที่ขอวงเงิน 6 พัน {{item.tg_landvalue_new
                            |
                            number}} ไร่
                          </span>
                        </div>
                        <!-- /.info-box-content -->
                      </div>
                    </div>

                  </div>
                  <div class="row mt-3">
                    <chart [type]="typeChart" [data]="dataChart19" [options]="optionsChart19" style="height: 600px;">
                    </chart>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>